import CountBadge from './CountBadge';

export default CountBadge;
